import Section from "./layouts/Section";
import {useEffect, useState} from "react";
import useFetch from "../hooks/useFetch";
import CONFIG from "../config/_config";

import news1Image from "../resources/images/newsPlaceholders/news1.jpg"
import news2Image from "../resources/images/newsPlaceholders/news2.jpg"
import news3Image from "../resources/images/newsPlaceholders/news3.jpg"

import NewsCarousel from "./NewsCarousel";
import {useTranslations} from "../store/LanguageProvider";

const randomNewsDescriptions = [
    "rand_news_desc1",
    "rand_news_desc2",
    "rand_news_desc3",
    "rand_news_desc4",
    "rand_news_desc5",
    "rand_news_desc6",
    "rand_news_desc7",
    "rand_news_desc8",
    "rand_news_desc9",
    "rand_news_desc10",
];

const randomNewsImages = [
    news1Image,
    news2Image,
    news3Image
]


const News = () => {
    const {response, makeRequest} = useFetch();
    const [news, setNews] = useState([]);
    const {translations, currentLang} = useTranslations();

    useEffect(() => {
        makeRequest(CONFIG.apiUrl + "menu_ajax.php", 'post', {getNews: 1});
    }, []);

    useEffect(() => {
        if (response && response.state === 'success'){
            if (response.data.length > 0) {
                const newsProducts = response.data.map((p, index) => {
                    let description = p.description;
                    if (!p.description || p.description === ''){
                        description = translations[randomNewsDescriptions[index % randomNewsDescriptions.length]];
                    } else if(p.translations[currentLang] && p.translations[currentLang].news_description) {
                        description = p.translations[currentLang].news_description;
                    }

                    return {
                        id: p.id,
                        title: p.name,
                        image: (!p.image || p.image === "") ? randomNewsImages[index % randomNewsImages.length] : p.image,
                        description: description
                    }
                });

                setNews(newsProducts);
            }
        }
    }, [response, translations]);

    return <>
        {news.length > 0 && <Section
                title={translations.last_news}
                subtitle={translations.last_news_sub}
                id='news'
                fullWidth
                noPadding>
            <NewsCarousel items={news} />
        </Section>}
    </>
}

export default News;